import { ProsItem } from 'components/views/Landing/section-pros.view'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

type ProsCardProps = ProsItem & {
  prosNumber: number
}
export default function ProsCard({ title, prosNumber, body, icon }: ProsCardProps) {
  const { t } = useTranslation('landing')
  const [isActive, setIsActive] = useState<boolean>(false)
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    function handleScroll() {
      if (ref.current) {
        const elemPos = ref.current.getBoundingClientRect()
        const innerH = window.innerHeight
        const centerY = innerH / 2
        const topBorder = centerY - 100
        const bottomBorder = centerY + 50
        if (elemPos.top >= topBorder && bottomBorder >= elemPos.top) {
          setIsActive(true)
        } else setIsActive(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className='flex items-start gap-8 py-5 relative' ref={ref}>
      <div
        className={`shadow rounded-2xl flex items-center justify-center py-2 px-5 w-[56px] md:w-[96px] h-[56px] md:h-[96px] border transition-all duration-300 ease-in ${
          isActive ? 'border-green-light-landing bg-green-light-landing/30' : 'border-transparent bg-secondary'
        }`}
      >
        <h1
          className={`font-bold text-[32px] md:text-[49px] leading-[140%] lg:leading-[68px] transition-all duration-300 ease-in ${
            isActive ? 'text-primary-landing' : 'text-grey-dark'
          }`}
        >
          {prosNumber}
        </h1>
      </div>
      <div className='sm:w-1/2'>
        <h1
          className={`font-bold text-[18px] leading-[140%] sm:text-[28px] sm:leading-[36px] mb-4  transition-all duration-300 ease-in ${
            isActive ? 'text-main' : 'text-grey-dark'
          }`}
        >
          {t(title)}
        </h1>
        <p className={`text-[14px] transition-all duration-300 ease-in  ${isActive ? 'text-main' : 'text-grey-dark'}`}>
          {t(body)}
        </p>
      </div>
      <img
        src={icon}
        className={`hidden sm:block absolute w-[200px] aspect-1 right-0 top-1/2 -translate-y-1/2  transition-all duration-300 ease-in ${
          isActive ? 'opacity-1' : 'opacity-0'
        }`}
        alt='PROS_ICON'
      />
    </div>
  )
}
